export default __webpack_public_path__ + "static/media/dj.0e05df07.jpg";